import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Modal } from "@ts-digital/vrc";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FEATURE_TOGGLE_TSPAY } from "../../../config";
import "./style.css";
import PageHeader from "../../general/pageHeader/pageHeader";
import HeaderScadenze from "../../../assets/img/Head-Scadenze-1x.svg";
import { Select, Tooltip } from "antd";
import { getBankLogo } from "../../tspay/bank-logos";
import VaporFullscreenOverlay from "../../vapor/fullscreenOverlay";
import TSPayAddAccountView from "../../../views/tspay/addAccount";
import { loadAccounts, renewConsent } from "../../../store/actions/tspay";
import { FormattedMessage } from "react-intl";
import { VaporRangeDatePicker } from "../../vapor";
import { DATETIME_FORMATZ_FOR_API } from "../../../constants/constants";
import moment from "moment";
import { useIntl } from "react-intl";

const Header = props => {
  const {    
    myType,
    customersView,
    datesConv,
    monthSelected,
    yearSelected,
    onChangeMonth,
    onChangeYear,
    onPrevMonth,
    onNextMonth,
    monthsOption,
    yearsOption,
    onChange,
    balanceDetailDialog,
    setBalanceDetailDialog
  } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const tspay = useSelector(state => state.tspay);
  const tspayAccounts = tspay.accounts.list;
  const [totalBalance, setTotalBalance] = useState(0);
  // const [balanceDetailDialog, setBalanceDetailDialog] = useState(false);
  const [newBankAccountDialog, setNewBankAccountDialog] = useState(false);
  const [SCAManagerStatusRenew, setSCAManagerStatusRenew] = useState(null);
  const [hasAccountExpired, setHasAccountExpired] = useState(false);
  const [configStatus, setConfigStatus] = useState("");

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    if (tspayAccounts) {
      let total = 0;
      tspayAccounts.map(account => {
        let isValid = new Date() <= new Date(account.consentExpireDate);
        if (!isValid) {
          setHasAccountExpired(true);
        }
        if (account.amount && isValid) {
          total += account.amount;
        }
        return null;
      });
      setTotalBalance(total);
    }
  }, [tspayAccounts]);

  useEffect(() => {
    if (SCAManagerStatusRenew) {
      let childWindowR = window.open(SCAManagerStatusRenew);
      let timer = setInterval(function() {
        if (childWindowR.closed) {
          clearInterval(timer);
          setSCAManagerStatusRenew(null);
        }
      }, 1000);
    } else {
      dispatch(loadAccounts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected
      ));
    }
  }, [SCAManagerStatusRenew]);

  const onRenewClick = account => {
    dispatch(renewConsent(
      auth, main.companyUuidSelected, account.consentId
    )).then(result => {
      setSCAManagerStatusRenew(result.scaManagerRedirectUrl);
    });
  };

  const renderAccounts = () => {
    let rows = [];
    tspayAccounts.map(account => {
      let isValid = new Date() <= new Date(account.consentExpireDate);
      const logoImg = getBankLogo(account.logoUrl);
      if (account.amount) {
        rows.push(<Tooltip
          color={"rgb(0, 80, 117)"}
          overlayClassName={isValid ? "" : "BankAccounts-tooltip"}
          title={
            !isValid && myType !== "STUDIO" ? (
              <div
                onClick={() => {
                  onRenewClick(account);
                }}
                style={{ cursor: "pointer" }}
              >
                <FormattedMessage id="deadlines.renewConsent" />                
              </div>
            ) : (
              ""
            )
          }
        >
          <div
            className={
              "dbx-tspay-payment-bank-accounts-card" +
              (!isValid
                ? " disabled"
                : account.amount < 0
                  ? " insufficient"
                  : "")
            }
          >
            <div
              className="deadlines-header-modal-accounts-table-col-1"
              style={{
                backgroundImage: `url(${logoImg})`
              }}
            ></div>
            <div className="deadlines-header-modal-accounts-table-col-2">
              <span>{account.bankName}</span>
              <span>{account.iban}</span>
            </div>
            {isValid ? (
              <div className="deadlines-header-modal-accounts-table-col-3">
                <span>
                  {account.amount.toLocaleString("it-IT", {
                    minimumFractionDigits: 2
                  })}{" "}
                  €
                </span>{" "}
                <span>
                  <FormattedMessage id="deadlines.availableBalance" />
                </span>{" "}
              </div>
            ) : (
              <div className="deadlines-header-modal-accounts-table-col-3">
                <span>{" - "}</span> <span>
                  <FormattedMessage id="deadlines.consentExpired" />
                </span>
              </div>
            )}
          </div>
        </Tooltip>);
      }
      return null;
    });
    if (myType !== "STUDIO") {
      rows.push(<div
        onClick={() => {
          setBalanceDetailDialog(false);
          setNewBankAccountDialog(true);
        }}
        className="deadlines-header-modal-accounts-table-row add-account"
      >
        <FontAwesomeIcon icon={("far", "plus")} /> 
        <FormattedMessage id="deadlines.addAccount" />
      </div>);
    }
    return rows;
  };
  const studioDeadlines =
    window.location.href.indexOf("scadenzecliente") === -1;
  return (
    <div className="deadlines-header-root">
      {newBankAccountDialog && (
        <VaporFullscreenOverlay
          title={intl.formatMessage({ id: "deadlines.addAccount"}).toUpperCase()}
          subtitle={intl.formatMessage({ id: "deadlines.addAccountTsPay"})}          
          width={"95vw"}
          onClose={() => {
            setNewBankAccountDialog(false);
            dispatch(loadAccounts(
              auth,
              main.accountantUuidSelected,
              main.companyUuidSelected
            ));
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:TSPAY-AGGIUNGICONTO");
            }
          }}
        >
          <TSPayAddAccountView
            isFullscreenOverlay={true}            
            onClose={() => {
              setNewBankAccountDialog(false);
              dispatch(loadAccounts(
                auth,
                main.accountantUuidSelected,
                main.companyUuidSelected
              ));
            }}
          />
        </VaporFullscreenOverlay>
      )}
      {myType !== "STUDIO"
        ? window.location.href.indexOf("/scadenzecliente") > -1 &&
        customersView === "list" && (
          <PageHeader
            title={
              studioDeadlines ? (
                intl.formatMessage({ id: "deadlines.header.titleAccountant"})
              ) : (
                <span>
                  {intl.formatMessage({ id: "deadlines.header.titleClient1"})}
                  <br />
                  {intl.formatMessage({ id: "deadlines.header.titleClient2"})} <strong>{intl.formatMessage({ id: "deadlines.header.titleClient3"})}</strong>
                </span>
              )
            }
            subtitle={
              FEATURE_TOGGLE_TSPAY === "true"
                ? studioDeadlines
                  ? intl.formatMessage({ id: "deadlines.header.subtitle"})                
                  : intl.formatMessage({ id: "deadlines.header.subtitlePay"})            
                : ""
            }
            image={`${HeaderScadenze}`}
            myType={myType}
            tooltip={"deadlines.tooltips.addNewDeadline"}
            onClick={() => {
              if (myType === "STUDIO") {
                navigate("/creascadenza");
              }
            }}
          />
        )
        : !(window.location.href.indexOf("/scadenzecliente") > -1) && (
          <PageHeader
            title={
              studioDeadlines ? (
                intl.formatMessage({ id: "deadlines.header.titleAccountant"})
              ) : (
                <span>
                  {intl.formatMessage({ id: "deadlines.header.titleClient1"})}
                  <br />
                  {intl.formatMessage({ id: "deadlines.header.titleClient2"})} <strong>{intl.formatMessage({ id: "deadlines.header.titleClient3"})}</strong>
                </span>
              )
            }
            subtitle={
              FEATURE_TOGGLE_TSPAY === "true"
                ? studioDeadlines
                  ? intl.formatMessage({ id: "deadlines.subTitleTsPayStudio"})                  
                  : intl.formatMessage({ id: "deadlines.subTitleTsPayClient"})
                : ""
            }
            image={`${HeaderScadenze}`}
            myType={myType}
            tooltip={"deadlines.tooltips.addNewDeadline"}
            onClick={() => {
              if (myType === "STUDIO") {
                navigate("/creascadenza");
              }
            }}
          />
        )}
      {/* {(window.location.href.indexOf("/scadenzecliente") > -1 && myType !== "STUDIO" && customersView === "list") ||
        (!window.location.href.indexOf("/scadenzecliente") > -1 && myType === "STUDIO") && (
        <PageHeader
          title={
            studioDeadlines ? (
              "Pianifica e controlla le scadenze dei tuoi clienti"
            ) : (
              <span>
                Pianifica e controlla
                <br />
                tutte le tue <strong>scadenze</strong>
              </span>
            )
          }
          subtitle={
            FEATURE_TOGGLE_TSPAY === "true"
              ? studioDeadlines
                ? "Gestisci le scadenze dei tuoi clienti con le funzioni fusione scadenze, sospendi, e crea nuove scadenze personalizzate."
                : "Tieni sotto controllo le scadenze, pianifica e paga con TSPay."
              : ""
          }
          image={`${HeaderScadenze}`}
          myType={myType}
          tooltip={"deadlines.tooltips.addNewDeadline"}
          onClick={() => {
            if (myType === "STUDIO") {
             navigate("/creascadenza");
            }
          }}
        />
      )} */}
      {balanceDetailDialog && (
        <Modal
          onClose={() => setBalanceDetailDialog(false)}
          visible={balanceDetailDialog}
          title={intl.formatMessage({ id: "deadlines.header.amount"})}
          outsideClosable={false}
        >
          <div className="deadlines-header-modal-content">
            <div className="deadlines-header-modal-total">
              {totalBalance.toLocaleString("it-IT", {
                minimumFractionDigits: 2
              })}
              €
            </div>
            <div className="deadlines-header-modal-accounts">
              <div className="deadlines-header-modal-accounts-title">
                {tspayAccounts.length > 0 ? (
                  <span>
                    <FormattedMessage id="deadlines.accounts" />                    
                  </span>
                ) : (
                  <span>
                    <FormattedMessage id="deadlines.balanceModalCopy" />
                  </span>
                )}
              </div>
              <div className="deadlines-header-modal-accounts-table">
                {renderAccounts()}
              </div>
            </div>
          </div>
        </Modal>
      )}
      <div className="deadlines-header-grey">
        <div className="deadlines-header-period">
          {!customersView || (customersView && customersView === "list") ? (
            <div /* className={"filterHeaderColumn left deadlines"}*/>
              <VaporRangeDatePicker
                className="deadlineRangePicker"
                size={"small"}              
                onChange={(e, values) => {                                                                                   
                  onChange(["fromDate", "toDate"], [values[0] ? moment(values[0], "DD/MM/YYYY").format(DATETIME_FORMATZ_FOR_API) : null, values[1] ? moment(values[1], "DD/MM/YYYY").format(DATETIME_FORMATZ_FOR_API) : null]);                                  
                }}
                value={datesConv}
              />
            </div>
          ) : null}

          {customersView &&
            (customersView === "calendar" ||
              customersView === "graph" ||
              customersView === "cashFlow") && (
            <div style={{ flex: "1 1 auto" }}>
              <div className="selectDate">
                <FontAwesomeIcon
                  style={{ margin: "30px 10px 0 20px", cursor: "pointer" }}
                  icon={["fas", "caret-left"]}
                  onClick={onPrevMonth}
                />
                <Select
                  className={["spacedSelect", "monthSelect"].join(" ")}
                  value={monthSelected}
                  onChange={value => onChangeMonth(value)}
                  size="large"
                >
                  {monthsOption}
                </Select>
                <FontAwesomeIcon
                  style={{ margin: "30px 20px 0 10px", cursor: "pointer" }}
                  icon={["fas", "caret-right"]}
                  onClick={onNextMonth}
                />

                <Select
                  className="spacedSelect"
                  value={yearSelected}
                  onChange={value => onChangeYear(value)}
                  size="large"
                >
                  {yearsOption}
                </Select>
              </div>
            </div>
          )}
        </div>
        <div className="deadlines-header-tspay">
          {configStatus === "LINKED" &&
            FEATURE_TOGGLE_TSPAY === "true" &&
            (myType !== "STUDIO" ||
              (myType === "STUDIO" &&
                window.location.href.indexOf("/scadenzecliente") > -1)) && (
          //  && (
            <div className="deadlines-header-balance">
              {hasAccountExpired ? (
                <Tooltip
                  title={
                    <FormattedMessage id="customerPage.landing.tsPayAccountantAlertMsg1" />
                  }
                >
                  <FontAwesomeIcon
                    className="deadlines-header-icon1"
                    color="#fdb927"
                    icon={["fas", "exclamation-triangle"]}
                  />
                </Tooltip>
              ) : null}
              <FontAwesomeIcon
                className="deadlines-header-icon1"
                icon={["far", "university"]}
              />
              <span className="deadlines-header-text"><FormattedMessage id="deadlines.balance" /></span>
              {!tspay.accounts.status.started &&
                  tspay.accounts.status.ended ? (
                  <React.Fragment>
                    <span className="deadlines-header-amount">
                      {totalBalance.toLocaleString("it-IT", {
                        minimumFractionDigits: 2
                      })}
                      €
                    </span>
                    <FontAwesomeIcon
                      className="deadlines-header-icon2"
                      icon={["far", "info-circle"]}
                      onClick={() => setBalanceDetailDialog(true)}
                    />
                  </React.Fragment>
                ) : (
                  <FontAwesomeIcon
                    className="deadlines-header-tspay-spinner"
                    icon={["far", "spinner"]}
                    spin
                  />
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
